export { default as MailIcon } from '~icons/lucide/mail';
